import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class EncodingInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only intercept POST, PUT, PATCH methods with a body
    if ((req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH') && req.body) {
      const bodyType = this.detectBodyType(req.body);

      if (bodyType === 'json') {
        const encodedBody = this.base64Encode(JSON.stringify(req.body)); // Base64 encode the body
        const clonedRequest = req.clone({
          body: encodedBody,
          setHeaders: {
            'X-Body-Encoding': 'base64', // Indicate the encoding type
            'Content-Type': 'application/json', // Specify the content type for JSON
          },
        });
        return next.handle(clonedRequest); // Forward the modified request
      }
    }

    return next.handle(req); // Proceed without modification for other methods
  }

  // Detect if the body is JSON-like (text-based) or binary-like
  private detectBodyType(body: any): 'json' | 'binary' {
    if (body instanceof FormData) {
      return 'binary'; // Skip encoding for file uploads
    }
    if (typeof body === 'string' || this.isPlainObject(body) || Array.isArray(body)) {
      return 'json';
    }
    return 'binary';
  }

  // Check if the object is a plain JS object (not a class instance)
  private isPlainObject(obj: any): boolean {
    return Object.prototype.toString.call(obj) === '[object Object]' && Object.getPrototypeOf(obj) === Object.prototype;
  }

  // Base64 encode with proper UTF-8 handling
  private base64Encode(str: string): string {
    return btoa(unescape(encodeURIComponent(str)));
  }
}
